// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
    background: '#F8F9FB',
  },
});

type Props = {
  children: React$Node,
};

function UnauthenticatedLayout({children}: Props) {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
}

export default UnauthenticatedLayout;
